module.exports = __webpack_public_path__ + "static/media/escrever-highlight-pt.d3fec374.svg";